/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as LoginRouteImport } from './routes/_login'
import { Route as BridgeRouteImport } from './routes/bridge'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard/settings'
import { Route as DashboardTempoRouteImport } from './routes/_dashboard/tempo'
import { Route as LoginIndexRouteImport } from './routes/_login/index'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as DashboardApplicationsIndexRouteImport } from './routes/_dashboard/applications/index'
import { Route as DashboardCompaniesIndexRouteImport } from './routes/_dashboard/companies/index'
import { Route as DashboardDashboardIndexRouteImport } from './routes/_dashboard/dashboard/index'
import { Route as DashboardFinanceIndexRouteImport } from './routes/_dashboard/finance/index'
import { Route as DashboardMessagingIndexRouteImport } from './routes/_dashboard/messaging/index'
import { Route as DashboardOrdersIndexRouteImport } from './routes/_dashboard/orders/index'
import { Route as DashboardTasksIndexRouteImport } from './routes/_dashboard/tasks/index'
import { Route as DashboardTempoImportRouteImport } from './routes/_dashboard/tempo/import'
import { Route as ShortlistInstanceTokenRouteImport } from './routes/shortlist/$instance/$token'

const DashboardAssistantLazyRouteImport = createFileRoute(
  '/_dashboard/assistant',
)()
const LoginForgotPasswordLazyRouteImport = createFileRoute(
  '/_login/forgot-password',
)()
const DashboardDocumentsDocumentIdLazyRouteImport = createFileRoute(
  '/_dashboard/documents/$documentId',
)()
const DashboardSettingsIndexLazyRouteImport = createFileRoute(
  '/_dashboard/settings/',
)()
const DashboardSettingsApplicantAvailabilityLazyRouteImport = createFileRoute(
  '/_dashboard/settings/applicant-availability',
)()
const DashboardSettingsApplicantExperienceLazyRouteImport = createFileRoute(
  '/_dashboard/settings/applicant-experience',
)()
const DashboardSettingsApplicationsLazyRouteImport = createFileRoute(
  '/_dashboard/settings/applications',
)()
const DashboardSettingsCalendarLazyRouteImport = createFileRoute(
  '/_dashboard/settings/calendar',
)()
const DashboardSettingsExtensionsLazyRouteImport = createFileRoute(
  '/_dashboard/settings/extensions',
)()
const DashboardSettingsGdprLazyRouteImport = createFileRoute(
  '/_dashboard/settings/gdpr',
)()
const DashboardSettingsInvoiceLazyRouteImport = createFileRoute(
  '/_dashboard/settings/invoice',
)()
const DashboardSettingsMandatoryFieldsLazyRouteImport = createFileRoute(
  '/_dashboard/settings/mandatory-fields',
)()
const DashboardSettingsMatchingScoreConfigLazyRouteImport = createFileRoute(
  '/_dashboard/settings/matching-score-config',
)()
const DashboardSettingsOffersLazyRouteImport = createFileRoute(
  '/_dashboard/settings/offers',
)()
const DashboardSettingsOrdersLazyRouteImport = createFileRoute(
  '/_dashboard/settings/orders',
)()
const DashboardSettingsResumesInboundLazyRouteImport = createFileRoute(
  '/_dashboard/settings/resumes-inbound',
)()
const DashboardSettingsSmsLazyRouteImport = createFileRoute(
  '/_dashboard/settings/sms',
)()
const DashboardSettingsSmsTemplatesLazyRouteImport = createFileRoute(
  '/_dashboard/settings/sms-templates',
)()
const DashboardSettingsTempoLazyRouteImport = createFileRoute(
  '/_dashboard/settings/tempo',
)()
const DashboardOrdersOrderIdIndexLazyRouteImport = createFileRoute(
  '/_dashboard/orders/$orderId/',
)()
const DashboardSettingsDocumentTemplatesIndexLazyRouteImport = createFileRoute(
  '/_dashboard/settings/document-templates/',
)()
const DashboardSettingsDocumentTemplatesTemplateIdLazyRouteImport =
  createFileRoute('/_dashboard/settings/document-templates/$templateId')()
const DashboardSettingsResumeTemplatesIndexLazyRouteImport = createFileRoute(
  '/_dashboard/settings/resume-templates/',
)()
const DashboardSettingsResumeTemplatesTemplateIdLazyRouteImport =
  createFileRoute('/_dashboard/settings/resume-templates/$templateId')()
const LoginChangePasswordInstanceTokenLazyRouteImport = createFileRoute(
  '/_login/change-password/$instance/$token',
)()
const DashboardSettingsAppUsersUserIdWebhooksLazyRouteImport = createFileRoute(
  '/_dashboard/settings/app-users/$userId/webhooks',
)()

const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/_login',
  getParentRoute: () => rootRouteImport,
} as any)
const BridgeRoute = BridgeRouteImport.update({
  id: '/bridge',
  path: '/bridge',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardAssistantLazyRoute = DashboardAssistantLazyRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/_dashboard/assistant.lazy').then((d) => d.Route),
)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTempoRoute = DashboardTempoRouteImport.update({
  id: '/tempo',
  path: '/tempo',
  getParentRoute: () => DashboardRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRoute,
} as any)
const LoginForgotPasswordLazyRoute = LoginForgotPasswordLazyRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => LoginRoute,
} as any).lazy(() =>
  import('./routes/_login/forgot-password.lazy').then((d) => d.Route),
)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardApplicationsIndexRoute =
  DashboardApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCompaniesIndexRoute = DashboardCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDashboardIndexRoute = DashboardDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDocumentsDocumentIdLazyRoute =
  DashboardDocumentsDocumentIdLazyRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/documents/$documentId.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardFinanceIndexRoute = DashboardFinanceIndexRouteImport.update({
  id: '/finance/',
  path: '/finance/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMessagingIndexRoute = DashboardMessagingIndexRouteImport.update({
  id: '/messaging/',
  path: '/messaging/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOrdersIndexRoute = DashboardOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsIndexLazyRoute =
  DashboardSettingsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/index.lazy').then((d) => d.Route),
  )
const DashboardSettingsApplicantAvailabilityLazyRoute =
  DashboardSettingsApplicantAvailabilityLazyRouteImport.update({
    id: '/applicant-availability',
    path: '/applicant-availability',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/applicant-availability.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsApplicantExperienceLazyRoute =
  DashboardSettingsApplicantExperienceLazyRouteImport.update({
    id: '/applicant-experience',
    path: '/applicant-experience',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/applicant-experience.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsApplicationsLazyRoute =
  DashboardSettingsApplicationsLazyRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/applications.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsCalendarLazyRoute =
  DashboardSettingsCalendarLazyRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/calendar.lazy').then((d) => d.Route),
  )
const DashboardSettingsExtensionsLazyRoute =
  DashboardSettingsExtensionsLazyRouteImport.update({
    id: '/extensions',
    path: '/extensions',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/extensions.lazy').then((d) => d.Route),
  )
const DashboardSettingsGdprLazyRoute =
  DashboardSettingsGdprLazyRouteImport.update({
    id: '/gdpr',
    path: '/gdpr',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/gdpr.lazy').then((d) => d.Route),
  )
const DashboardSettingsInvoiceLazyRoute =
  DashboardSettingsInvoiceLazyRouteImport.update({
    id: '/invoice',
    path: '/invoice',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/invoice.lazy').then((d) => d.Route),
  )
const DashboardSettingsMandatoryFieldsLazyRoute =
  DashboardSettingsMandatoryFieldsLazyRouteImport.update({
    id: '/mandatory-fields',
    path: '/mandatory-fields',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/mandatory-fields.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsMatchingScoreConfigLazyRoute =
  DashboardSettingsMatchingScoreConfigLazyRouteImport.update({
    id: '/matching-score-config',
    path: '/matching-score-config',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/matching-score-config.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsOffersLazyRoute =
  DashboardSettingsOffersLazyRouteImport.update({
    id: '/offers',
    path: '/offers',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/offers.lazy').then((d) => d.Route),
  )
const DashboardSettingsOrdersLazyRoute =
  DashboardSettingsOrdersLazyRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/orders.lazy').then((d) => d.Route),
  )
const DashboardSettingsResumesInboundLazyRoute =
  DashboardSettingsResumesInboundLazyRouteImport.update({
    id: '/resumes-inbound',
    path: '/resumes-inbound',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/resumes-inbound.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsSmsLazyRoute =
  DashboardSettingsSmsLazyRouteImport.update({
    id: '/sms',
    path: '/sms',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/sms.lazy').then((d) => d.Route),
  )
const DashboardSettingsSmsTemplatesLazyRoute =
  DashboardSettingsSmsTemplatesLazyRouteImport.update({
    id: '/sms-templates',
    path: '/sms-templates',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/sms-templates.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsTempoLazyRoute =
  DashboardSettingsTempoLazyRouteImport.update({
    id: '/tempo',
    path: '/tempo',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/tempo.lazy').then((d) => d.Route),
  )
const DashboardTasksIndexRoute = DashboardTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTempoImportRoute = DashboardTempoImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => DashboardTempoRoute,
} as any).lazy(() =>
  import('./routes/_dashboard/tempo/import.lazy').then((d) => d.Route),
)
const ShortlistInstanceTokenRoute = ShortlistInstanceTokenRouteImport.update({
  id: '/shortlist/$instance/$token',
  path: '/shortlist/$instance/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardOrdersOrderIdIndexLazyRoute =
  DashboardOrdersOrderIdIndexLazyRouteImport.update({
    id: '/orders/$orderId/',
    path: '/orders/$orderId/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/orders/$orderId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsDocumentTemplatesIndexLazyRoute =
  DashboardSettingsDocumentTemplatesIndexLazyRouteImport.update({
    id: '/document-templates/',
    path: '/document-templates/',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/document-templates/index.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsDocumentTemplatesTemplateIdLazyRoute =
  DashboardSettingsDocumentTemplatesTemplateIdLazyRouteImport.update({
    id: '/document-templates/$templateId',
    path: '/document-templates/$templateId',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/document-templates/$templateId.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsResumeTemplatesIndexLazyRoute =
  DashboardSettingsResumeTemplatesIndexLazyRouteImport.update({
    id: '/resume-templates/',
    path: '/resume-templates/',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/resume-templates/index.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsResumeTemplatesTemplateIdLazyRoute =
  DashboardSettingsResumeTemplatesTemplateIdLazyRouteImport.update({
    id: '/resume-templates/$templateId',
    path: '/resume-templates/$templateId',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/resume-templates/$templateId.lazy').then(
      (d) => d.Route,
    ),
  )
const LoginChangePasswordInstanceTokenLazyRoute =
  LoginChangePasswordInstanceTokenLazyRouteImport.update({
    id: '/change-password/$instance/$token',
    path: '/change-password/$instance/$token',
    getParentRoute: () => LoginRoute,
  } as any).lazy(() =>
    import('./routes/_login/change-password/$instance/$token.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardSettingsAppUsersUserIdWebhooksLazyRoute =
  DashboardSettingsAppUsersUserIdWebhooksLazyRouteImport.update({
    id: '/app-users/$userId/webhooks',
    path: '/app-users/$userId/webhooks',
    getParentRoute: () => DashboardSettingsRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/settings/app-users/$userId/webhooks.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof LoginIndexRoute
  '/bridge': typeof BridgeRoute
  '/settings': typeof DashboardSettingsRouteWithChildren
  '/tempo': typeof DashboardTempoRouteWithChildren
  '/oauth/consent': typeof OauthConsentRoute
  '/assistant': typeof DashboardAssistantLazyRoute
  '/forgot-password': typeof LoginForgotPasswordLazyRoute
  '/tempo/import': typeof DashboardTempoImportRoute
  '/shortlist/$instance/$token': typeof ShortlistInstanceTokenRoute
  '/documents/$documentId': typeof DashboardDocumentsDocumentIdLazyRoute
  '/settings/applicant-availability': typeof DashboardSettingsApplicantAvailabilityLazyRoute
  '/settings/applicant-experience': typeof DashboardSettingsApplicantExperienceLazyRoute
  '/settings/applications': typeof DashboardSettingsApplicationsLazyRoute
  '/settings/calendar': typeof DashboardSettingsCalendarLazyRoute
  '/settings/extensions': typeof DashboardSettingsExtensionsLazyRoute
  '/settings/gdpr': typeof DashboardSettingsGdprLazyRoute
  '/settings/invoice': typeof DashboardSettingsInvoiceLazyRoute
  '/settings/mandatory-fields': typeof DashboardSettingsMandatoryFieldsLazyRoute
  '/settings/matching-score-config': typeof DashboardSettingsMatchingScoreConfigLazyRoute
  '/settings/offers': typeof DashboardSettingsOffersLazyRoute
  '/settings/orders': typeof DashboardSettingsOrdersLazyRoute
  '/settings/resumes-inbound': typeof DashboardSettingsResumesInboundLazyRoute
  '/settings/sms': typeof DashboardSettingsSmsLazyRoute
  '/settings/sms-templates': typeof DashboardSettingsSmsTemplatesLazyRoute
  '/settings/tempo': typeof DashboardSettingsTempoLazyRoute
  '/applications/': typeof DashboardApplicationsIndexRoute
  '/companies/': typeof DashboardCompaniesIndexRoute
  '/dashboard/': typeof DashboardDashboardIndexRoute
  '/finance/': typeof DashboardFinanceIndexRoute
  '/messaging/': typeof DashboardMessagingIndexRoute
  '/orders/': typeof DashboardOrdersIndexRoute
  '/tasks/': typeof DashboardTasksIndexRoute
  '/settings/': typeof DashboardSettingsIndexLazyRoute
  '/settings/document-templates/$templateId': typeof DashboardSettingsDocumentTemplatesTemplateIdLazyRoute
  '/settings/resume-templates/$templateId': typeof DashboardSettingsResumeTemplatesTemplateIdLazyRoute
  '/change-password/$instance/$token': typeof LoginChangePasswordInstanceTokenLazyRoute
  '/orders/$orderId/': typeof DashboardOrdersOrderIdIndexLazyRoute
  '/settings/document-templates/': typeof DashboardSettingsDocumentTemplatesIndexLazyRoute
  '/settings/resume-templates/': typeof DashboardSettingsResumeTemplatesIndexLazyRoute
  '/settings/app-users/$userId/webhooks': typeof DashboardSettingsAppUsersUserIdWebhooksLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof LoginIndexRoute
  '/bridge': typeof BridgeRoute
  '/tempo': typeof DashboardTempoRouteWithChildren
  '/oauth/consent': typeof OauthConsentRoute
  '/assistant': typeof DashboardAssistantLazyRoute
  '/forgot-password': typeof LoginForgotPasswordLazyRoute
  '/tempo/import': typeof DashboardTempoImportRoute
  '/shortlist/$instance/$token': typeof ShortlistInstanceTokenRoute
  '/documents/$documentId': typeof DashboardDocumentsDocumentIdLazyRoute
  '/settings/applicant-availability': typeof DashboardSettingsApplicantAvailabilityLazyRoute
  '/settings/applicant-experience': typeof DashboardSettingsApplicantExperienceLazyRoute
  '/settings/applications': typeof DashboardSettingsApplicationsLazyRoute
  '/settings/calendar': typeof DashboardSettingsCalendarLazyRoute
  '/settings/extensions': typeof DashboardSettingsExtensionsLazyRoute
  '/settings/gdpr': typeof DashboardSettingsGdprLazyRoute
  '/settings/invoice': typeof DashboardSettingsInvoiceLazyRoute
  '/settings/mandatory-fields': typeof DashboardSettingsMandatoryFieldsLazyRoute
  '/settings/matching-score-config': typeof DashboardSettingsMatchingScoreConfigLazyRoute
  '/settings/offers': typeof DashboardSettingsOffersLazyRoute
  '/settings/orders': typeof DashboardSettingsOrdersLazyRoute
  '/settings/resumes-inbound': typeof DashboardSettingsResumesInboundLazyRoute
  '/settings/sms': typeof DashboardSettingsSmsLazyRoute
  '/settings/sms-templates': typeof DashboardSettingsSmsTemplatesLazyRoute
  '/settings/tempo': typeof DashboardSettingsTempoLazyRoute
  '/applications': typeof DashboardApplicationsIndexRoute
  '/companies': typeof DashboardCompaniesIndexRoute
  '/dashboard': typeof DashboardDashboardIndexRoute
  '/finance': typeof DashboardFinanceIndexRoute
  '/messaging': typeof DashboardMessagingIndexRoute
  '/orders': typeof DashboardOrdersIndexRoute
  '/tasks': typeof DashboardTasksIndexRoute
  '/settings': typeof DashboardSettingsIndexLazyRoute
  '/settings/document-templates/$templateId': typeof DashboardSettingsDocumentTemplatesTemplateIdLazyRoute
  '/settings/resume-templates/$templateId': typeof DashboardSettingsResumeTemplatesTemplateIdLazyRoute
  '/change-password/$instance/$token': typeof LoginChangePasswordInstanceTokenLazyRoute
  '/orders/$orderId': typeof DashboardOrdersOrderIdIndexLazyRoute
  '/settings/document-templates': typeof DashboardSettingsDocumentTemplatesIndexLazyRoute
  '/settings/resume-templates': typeof DashboardSettingsResumeTemplatesIndexLazyRoute
  '/settings/app-users/$userId/webhooks': typeof DashboardSettingsAppUsersUserIdWebhooksLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_login': typeof LoginRouteWithChildren
  '/bridge': typeof BridgeRoute
  '/_dashboard/settings': typeof DashboardSettingsRouteWithChildren
  '/_dashboard/tempo': typeof DashboardTempoRouteWithChildren
  '/oauth/consent': typeof OauthConsentRoute
  '/_dashboard/assistant': typeof DashboardAssistantLazyRoute
  '/_login/forgot-password': typeof LoginForgotPasswordLazyRoute
  '/_login/': typeof LoginIndexRoute
  '/_dashboard/tempo/import': typeof DashboardTempoImportRoute
  '/shortlist/$instance/$token': typeof ShortlistInstanceTokenRoute
  '/_dashboard/documents/$documentId': typeof DashboardDocumentsDocumentIdLazyRoute
  '/_dashboard/settings/applicant-availability': typeof DashboardSettingsApplicantAvailabilityLazyRoute
  '/_dashboard/settings/applicant-experience': typeof DashboardSettingsApplicantExperienceLazyRoute
  '/_dashboard/settings/applications': typeof DashboardSettingsApplicationsLazyRoute
  '/_dashboard/settings/calendar': typeof DashboardSettingsCalendarLazyRoute
  '/_dashboard/settings/extensions': typeof DashboardSettingsExtensionsLazyRoute
  '/_dashboard/settings/gdpr': typeof DashboardSettingsGdprLazyRoute
  '/_dashboard/settings/invoice': typeof DashboardSettingsInvoiceLazyRoute
  '/_dashboard/settings/mandatory-fields': typeof DashboardSettingsMandatoryFieldsLazyRoute
  '/_dashboard/settings/matching-score-config': typeof DashboardSettingsMatchingScoreConfigLazyRoute
  '/_dashboard/settings/offers': typeof DashboardSettingsOffersLazyRoute
  '/_dashboard/settings/orders': typeof DashboardSettingsOrdersLazyRoute
  '/_dashboard/settings/resumes-inbound': typeof DashboardSettingsResumesInboundLazyRoute
  '/_dashboard/settings/sms': typeof DashboardSettingsSmsLazyRoute
  '/_dashboard/settings/sms-templates': typeof DashboardSettingsSmsTemplatesLazyRoute
  '/_dashboard/settings/tempo': typeof DashboardSettingsTempoLazyRoute
  '/_dashboard/applications/': typeof DashboardApplicationsIndexRoute
  '/_dashboard/companies/': typeof DashboardCompaniesIndexRoute
  '/_dashboard/dashboard/': typeof DashboardDashboardIndexRoute
  '/_dashboard/finance/': typeof DashboardFinanceIndexRoute
  '/_dashboard/messaging/': typeof DashboardMessagingIndexRoute
  '/_dashboard/orders/': typeof DashboardOrdersIndexRoute
  '/_dashboard/tasks/': typeof DashboardTasksIndexRoute
  '/_dashboard/settings/': typeof DashboardSettingsIndexLazyRoute
  '/_dashboard/settings/document-templates/$templateId': typeof DashboardSettingsDocumentTemplatesTemplateIdLazyRoute
  '/_dashboard/settings/resume-templates/$templateId': typeof DashboardSettingsResumeTemplatesTemplateIdLazyRoute
  '/_login/change-password/$instance/$token': typeof LoginChangePasswordInstanceTokenLazyRoute
  '/_dashboard/orders/$orderId/': typeof DashboardOrdersOrderIdIndexLazyRoute
  '/_dashboard/settings/document-templates/': typeof DashboardSettingsDocumentTemplatesIndexLazyRoute
  '/_dashboard/settings/resume-templates/': typeof DashboardSettingsResumeTemplatesIndexLazyRoute
  '/_dashboard/settings/app-users/$userId/webhooks': typeof DashboardSettingsAppUsersUserIdWebhooksLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bridge'
    | '/settings'
    | '/tempo'
    | '/oauth/consent'
    | '/assistant'
    | '/forgot-password'
    | '/tempo/import'
    | '/shortlist/$instance/$token'
    | '/documents/$documentId'
    | '/settings/applicant-availability'
    | '/settings/applicant-experience'
    | '/settings/applications'
    | '/settings/calendar'
    | '/settings/extensions'
    | '/settings/gdpr'
    | '/settings/invoice'
    | '/settings/mandatory-fields'
    | '/settings/matching-score-config'
    | '/settings/offers'
    | '/settings/orders'
    | '/settings/resumes-inbound'
    | '/settings/sms'
    | '/settings/sms-templates'
    | '/settings/tempo'
    | '/applications/'
    | '/companies/'
    | '/dashboard/'
    | '/finance/'
    | '/messaging/'
    | '/orders/'
    | '/tasks/'
    | '/settings/'
    | '/settings/document-templates/$templateId'
    | '/settings/resume-templates/$templateId'
    | '/change-password/$instance/$token'
    | '/orders/$orderId/'
    | '/settings/document-templates/'
    | '/settings/resume-templates/'
    | '/settings/app-users/$userId/webhooks'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bridge'
    | '/tempo'
    | '/oauth/consent'
    | '/assistant'
    | '/forgot-password'
    | '/tempo/import'
    | '/shortlist/$instance/$token'
    | '/documents/$documentId'
    | '/settings/applicant-availability'
    | '/settings/applicant-experience'
    | '/settings/applications'
    | '/settings/calendar'
    | '/settings/extensions'
    | '/settings/gdpr'
    | '/settings/invoice'
    | '/settings/mandatory-fields'
    | '/settings/matching-score-config'
    | '/settings/offers'
    | '/settings/orders'
    | '/settings/resumes-inbound'
    | '/settings/sms'
    | '/settings/sms-templates'
    | '/settings/tempo'
    | '/applications'
    | '/companies'
    | '/dashboard'
    | '/finance'
    | '/messaging'
    | '/orders'
    | '/tasks'
    | '/settings'
    | '/settings/document-templates/$templateId'
    | '/settings/resume-templates/$templateId'
    | '/change-password/$instance/$token'
    | '/orders/$orderId'
    | '/settings/document-templates'
    | '/settings/resume-templates'
    | '/settings/app-users/$userId/webhooks'
  id:
    | '__root__'
    | '/_dashboard'
    | '/_login'
    | '/bridge'
    | '/_dashboard/settings'
    | '/_dashboard/tempo'
    | '/oauth/consent'
    | '/_dashboard/assistant'
    | '/_login/forgot-password'
    | '/_login/'
    | '/_dashboard/tempo/import'
    | '/shortlist/$instance/$token'
    | '/_dashboard/documents/$documentId'
    | '/_dashboard/settings/applicant-availability'
    | '/_dashboard/settings/applicant-experience'
    | '/_dashboard/settings/applications'
    | '/_dashboard/settings/calendar'
    | '/_dashboard/settings/extensions'
    | '/_dashboard/settings/gdpr'
    | '/_dashboard/settings/invoice'
    | '/_dashboard/settings/mandatory-fields'
    | '/_dashboard/settings/matching-score-config'
    | '/_dashboard/settings/offers'
    | '/_dashboard/settings/orders'
    | '/_dashboard/settings/resumes-inbound'
    | '/_dashboard/settings/sms'
    | '/_dashboard/settings/sms-templates'
    | '/_dashboard/settings/tempo'
    | '/_dashboard/applications/'
    | '/_dashboard/companies/'
    | '/_dashboard/dashboard/'
    | '/_dashboard/finance/'
    | '/_dashboard/messaging/'
    | '/_dashboard/orders/'
    | '/_dashboard/tasks/'
    | '/_dashboard/settings/'
    | '/_dashboard/settings/document-templates/$templateId'
    | '/_dashboard/settings/resume-templates/$templateId'
    | '/_login/change-password/$instance/$token'
    | '/_dashboard/orders/$orderId/'
    | '/_dashboard/settings/document-templates/'
    | '/_dashboard/settings/resume-templates/'
    | '/_dashboard/settings/app-users/$userId/webhooks'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRouteWithChildren
  BridgeRoute: typeof BridgeRoute
  OauthConsentRoute: typeof OauthConsentRoute
  ShortlistInstanceTokenRoute: typeof ShortlistInstanceTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login': {
      id: '/_login'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bridge': {
      id: '/bridge'
      path: '/bridge'
      fullPath: '/bridge'
      preLoaderRoute: typeof BridgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/assistant': {
      id: '/_dashboard/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof DashboardAssistantLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/tempo': {
      id: '/_dashboard/tempo'
      path: '/tempo'
      fullPath: '/tempo'
      preLoaderRoute: typeof DashboardTempoRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_login/': {
      id: '/_login/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_login/forgot-password': {
      id: '/_login/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof LoginForgotPasswordLazyRouteImport
      parentRoute: typeof LoginRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/applications/': {
      id: '/_dashboard/applications/'
      path: '/applications'
      fullPath: '/applications/'
      preLoaderRoute: typeof DashboardApplicationsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/companies/': {
      id: '/_dashboard/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof DashboardCompaniesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard/': {
      id: '/_dashboard/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardDashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/documents/$documentId': {
      id: '/_dashboard/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/documents/$documentId'
      preLoaderRoute: typeof DashboardDocumentsDocumentIdLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/finance/': {
      id: '/_dashboard/finance/'
      path: '/finance'
      fullPath: '/finance/'
      preLoaderRoute: typeof DashboardFinanceIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/messaging/': {
      id: '/_dashboard/messaging/'
      path: '/messaging'
      fullPath: '/messaging/'
      preLoaderRoute: typeof DashboardMessagingIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/orders/': {
      id: '/_dashboard/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof DashboardOrdersIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings/': {
      id: '/_dashboard/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof DashboardSettingsIndexLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/applicant-availability': {
      id: '/_dashboard/settings/applicant-availability'
      path: '/applicant-availability'
      fullPath: '/settings/applicant-availability'
      preLoaderRoute: typeof DashboardSettingsApplicantAvailabilityLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/applicant-experience': {
      id: '/_dashboard/settings/applicant-experience'
      path: '/applicant-experience'
      fullPath: '/settings/applicant-experience'
      preLoaderRoute: typeof DashboardSettingsApplicantExperienceLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/applications': {
      id: '/_dashboard/settings/applications'
      path: '/applications'
      fullPath: '/settings/applications'
      preLoaderRoute: typeof DashboardSettingsApplicationsLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/calendar': {
      id: '/_dashboard/settings/calendar'
      path: '/calendar'
      fullPath: '/settings/calendar'
      preLoaderRoute: typeof DashboardSettingsCalendarLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/extensions': {
      id: '/_dashboard/settings/extensions'
      path: '/extensions'
      fullPath: '/settings/extensions'
      preLoaderRoute: typeof DashboardSettingsExtensionsLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/gdpr': {
      id: '/_dashboard/settings/gdpr'
      path: '/gdpr'
      fullPath: '/settings/gdpr'
      preLoaderRoute: typeof DashboardSettingsGdprLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/invoice': {
      id: '/_dashboard/settings/invoice'
      path: '/invoice'
      fullPath: '/settings/invoice'
      preLoaderRoute: typeof DashboardSettingsInvoiceLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/mandatory-fields': {
      id: '/_dashboard/settings/mandatory-fields'
      path: '/mandatory-fields'
      fullPath: '/settings/mandatory-fields'
      preLoaderRoute: typeof DashboardSettingsMandatoryFieldsLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/matching-score-config': {
      id: '/_dashboard/settings/matching-score-config'
      path: '/matching-score-config'
      fullPath: '/settings/matching-score-config'
      preLoaderRoute: typeof DashboardSettingsMatchingScoreConfigLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/offers': {
      id: '/_dashboard/settings/offers'
      path: '/offers'
      fullPath: '/settings/offers'
      preLoaderRoute: typeof DashboardSettingsOffersLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/orders': {
      id: '/_dashboard/settings/orders'
      path: '/orders'
      fullPath: '/settings/orders'
      preLoaderRoute: typeof DashboardSettingsOrdersLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/resumes-inbound': {
      id: '/_dashboard/settings/resumes-inbound'
      path: '/resumes-inbound'
      fullPath: '/settings/resumes-inbound'
      preLoaderRoute: typeof DashboardSettingsResumesInboundLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/sms': {
      id: '/_dashboard/settings/sms'
      path: '/sms'
      fullPath: '/settings/sms'
      preLoaderRoute: typeof DashboardSettingsSmsLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/sms-templates': {
      id: '/_dashboard/settings/sms-templates'
      path: '/sms-templates'
      fullPath: '/settings/sms-templates'
      preLoaderRoute: typeof DashboardSettingsSmsTemplatesLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/tempo': {
      id: '/_dashboard/settings/tempo'
      path: '/tempo'
      fullPath: '/settings/tempo'
      preLoaderRoute: typeof DashboardSettingsTempoLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/tasks/': {
      id: '/_dashboard/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof DashboardTasksIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/tempo/import': {
      id: '/_dashboard/tempo/import'
      path: '/import'
      fullPath: '/tempo/import'
      preLoaderRoute: typeof DashboardTempoImportRouteImport
      parentRoute: typeof DashboardTempoRoute
    }
    '/shortlist/$instance/$token': {
      id: '/shortlist/$instance/$token'
      path: '/shortlist/$instance/$token'
      fullPath: '/shortlist/$instance/$token'
      preLoaderRoute: typeof ShortlistInstanceTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/orders/$orderId/': {
      id: '/_dashboard/orders/$orderId/'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId/'
      preLoaderRoute: typeof DashboardOrdersOrderIdIndexLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings/document-templates/': {
      id: '/_dashboard/settings/document-templates/'
      path: '/document-templates'
      fullPath: '/settings/document-templates/'
      preLoaderRoute: typeof DashboardSettingsDocumentTemplatesIndexLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/document-templates/$templateId': {
      id: '/_dashboard/settings/document-templates/$templateId'
      path: '/document-templates/$templateId'
      fullPath: '/settings/document-templates/$templateId'
      preLoaderRoute: typeof DashboardSettingsDocumentTemplatesTemplateIdLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/resume-templates/': {
      id: '/_dashboard/settings/resume-templates/'
      path: '/resume-templates'
      fullPath: '/settings/resume-templates/'
      preLoaderRoute: typeof DashboardSettingsResumeTemplatesIndexLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/resume-templates/$templateId': {
      id: '/_dashboard/settings/resume-templates/$templateId'
      path: '/resume-templates/$templateId'
      fullPath: '/settings/resume-templates/$templateId'
      preLoaderRoute: typeof DashboardSettingsResumeTemplatesTemplateIdLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_login/change-password/$instance/$token': {
      id: '/_login/change-password/$instance/$token'
      path: '/change-password/$instance/$token'
      fullPath: '/change-password/$instance/$token'
      preLoaderRoute: typeof LoginChangePasswordInstanceTokenLazyRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_dashboard/settings/app-users/$userId/webhooks': {
      id: '/_dashboard/settings/app-users/$userId/webhooks'
      path: '/app-users/$userId/webhooks'
      fullPath: '/settings/app-users/$userId/webhooks'
      preLoaderRoute: typeof DashboardSettingsAppUsersUserIdWebhooksLazyRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
  }
}

interface DashboardSettingsRouteChildren {
  DashboardSettingsApplicantAvailabilityLazyRoute: typeof DashboardSettingsApplicantAvailabilityLazyRoute
  DashboardSettingsApplicantExperienceLazyRoute: typeof DashboardSettingsApplicantExperienceLazyRoute
  DashboardSettingsApplicationsLazyRoute: typeof DashboardSettingsApplicationsLazyRoute
  DashboardSettingsCalendarLazyRoute: typeof DashboardSettingsCalendarLazyRoute
  DashboardSettingsExtensionsLazyRoute: typeof DashboardSettingsExtensionsLazyRoute
  DashboardSettingsGdprLazyRoute: typeof DashboardSettingsGdprLazyRoute
  DashboardSettingsInvoiceLazyRoute: typeof DashboardSettingsInvoiceLazyRoute
  DashboardSettingsMandatoryFieldsLazyRoute: typeof DashboardSettingsMandatoryFieldsLazyRoute
  DashboardSettingsMatchingScoreConfigLazyRoute: typeof DashboardSettingsMatchingScoreConfigLazyRoute
  DashboardSettingsOffersLazyRoute: typeof DashboardSettingsOffersLazyRoute
  DashboardSettingsOrdersLazyRoute: typeof DashboardSettingsOrdersLazyRoute
  DashboardSettingsResumesInboundLazyRoute: typeof DashboardSettingsResumesInboundLazyRoute
  DashboardSettingsSmsLazyRoute: typeof DashboardSettingsSmsLazyRoute
  DashboardSettingsSmsTemplatesLazyRoute: typeof DashboardSettingsSmsTemplatesLazyRoute
  DashboardSettingsTempoLazyRoute: typeof DashboardSettingsTempoLazyRoute
  DashboardSettingsIndexLazyRoute: typeof DashboardSettingsIndexLazyRoute
  DashboardSettingsDocumentTemplatesTemplateIdLazyRoute: typeof DashboardSettingsDocumentTemplatesTemplateIdLazyRoute
  DashboardSettingsResumeTemplatesTemplateIdLazyRoute: typeof DashboardSettingsResumeTemplatesTemplateIdLazyRoute
  DashboardSettingsDocumentTemplatesIndexLazyRoute: typeof DashboardSettingsDocumentTemplatesIndexLazyRoute
  DashboardSettingsResumeTemplatesIndexLazyRoute: typeof DashboardSettingsResumeTemplatesIndexLazyRoute
  DashboardSettingsAppUsersUserIdWebhooksLazyRoute: typeof DashboardSettingsAppUsersUserIdWebhooksLazyRoute
}

const DashboardSettingsRouteChildren: DashboardSettingsRouteChildren = {
  DashboardSettingsApplicantAvailabilityLazyRoute:
    DashboardSettingsApplicantAvailabilityLazyRoute,
  DashboardSettingsApplicantExperienceLazyRoute:
    DashboardSettingsApplicantExperienceLazyRoute,
  DashboardSettingsApplicationsLazyRoute:
    DashboardSettingsApplicationsLazyRoute,
  DashboardSettingsCalendarLazyRoute: DashboardSettingsCalendarLazyRoute,
  DashboardSettingsExtensionsLazyRoute: DashboardSettingsExtensionsLazyRoute,
  DashboardSettingsGdprLazyRoute: DashboardSettingsGdprLazyRoute,
  DashboardSettingsInvoiceLazyRoute: DashboardSettingsInvoiceLazyRoute,
  DashboardSettingsMandatoryFieldsLazyRoute:
    DashboardSettingsMandatoryFieldsLazyRoute,
  DashboardSettingsMatchingScoreConfigLazyRoute:
    DashboardSettingsMatchingScoreConfigLazyRoute,
  DashboardSettingsOffersLazyRoute: DashboardSettingsOffersLazyRoute,
  DashboardSettingsOrdersLazyRoute: DashboardSettingsOrdersLazyRoute,
  DashboardSettingsResumesInboundLazyRoute:
    DashboardSettingsResumesInboundLazyRoute,
  DashboardSettingsSmsLazyRoute: DashboardSettingsSmsLazyRoute,
  DashboardSettingsSmsTemplatesLazyRoute:
    DashboardSettingsSmsTemplatesLazyRoute,
  DashboardSettingsTempoLazyRoute: DashboardSettingsTempoLazyRoute,
  DashboardSettingsIndexLazyRoute: DashboardSettingsIndexLazyRoute,
  DashboardSettingsDocumentTemplatesTemplateIdLazyRoute:
    DashboardSettingsDocumentTemplatesTemplateIdLazyRoute,
  DashboardSettingsResumeTemplatesTemplateIdLazyRoute:
    DashboardSettingsResumeTemplatesTemplateIdLazyRoute,
  DashboardSettingsDocumentTemplatesIndexLazyRoute:
    DashboardSettingsDocumentTemplatesIndexLazyRoute,
  DashboardSettingsResumeTemplatesIndexLazyRoute:
    DashboardSettingsResumeTemplatesIndexLazyRoute,
  DashboardSettingsAppUsersUserIdWebhooksLazyRoute:
    DashboardSettingsAppUsersUserIdWebhooksLazyRoute,
}

const DashboardSettingsRouteWithChildren =
  DashboardSettingsRoute._addFileChildren(DashboardSettingsRouteChildren)

interface DashboardTempoRouteChildren {
  DashboardTempoImportRoute: typeof DashboardTempoImportRoute
}

const DashboardTempoRouteChildren: DashboardTempoRouteChildren = {
  DashboardTempoImportRoute: DashboardTempoImportRoute,
}

const DashboardTempoRouteWithChildren = DashboardTempoRoute._addFileChildren(
  DashboardTempoRouteChildren,
)

interface DashboardRouteChildren {
  DashboardSettingsRoute: typeof DashboardSettingsRouteWithChildren
  DashboardTempoRoute: typeof DashboardTempoRouteWithChildren
  DashboardAssistantLazyRoute: typeof DashboardAssistantLazyRoute
  DashboardDocumentsDocumentIdLazyRoute: typeof DashboardDocumentsDocumentIdLazyRoute
  DashboardApplicationsIndexRoute: typeof DashboardApplicationsIndexRoute
  DashboardCompaniesIndexRoute: typeof DashboardCompaniesIndexRoute
  DashboardDashboardIndexRoute: typeof DashboardDashboardIndexRoute
  DashboardFinanceIndexRoute: typeof DashboardFinanceIndexRoute
  DashboardMessagingIndexRoute: typeof DashboardMessagingIndexRoute
  DashboardOrdersIndexRoute: typeof DashboardOrdersIndexRoute
  DashboardTasksIndexRoute: typeof DashboardTasksIndexRoute
  DashboardOrdersOrderIdIndexLazyRoute: typeof DashboardOrdersOrderIdIndexLazyRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardSettingsRoute: DashboardSettingsRouteWithChildren,
  DashboardTempoRoute: DashboardTempoRouteWithChildren,
  DashboardAssistantLazyRoute: DashboardAssistantLazyRoute,
  DashboardDocumentsDocumentIdLazyRoute: DashboardDocumentsDocumentIdLazyRoute,
  DashboardApplicationsIndexRoute: DashboardApplicationsIndexRoute,
  DashboardCompaniesIndexRoute: DashboardCompaniesIndexRoute,
  DashboardDashboardIndexRoute: DashboardDashboardIndexRoute,
  DashboardFinanceIndexRoute: DashboardFinanceIndexRoute,
  DashboardMessagingIndexRoute: DashboardMessagingIndexRoute,
  DashboardOrdersIndexRoute: DashboardOrdersIndexRoute,
  DashboardTasksIndexRoute: DashboardTasksIndexRoute,
  DashboardOrdersOrderIdIndexLazyRoute: DashboardOrdersOrderIdIndexLazyRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface LoginRouteChildren {
  LoginForgotPasswordLazyRoute: typeof LoginForgotPasswordLazyRoute
  LoginIndexRoute: typeof LoginIndexRoute
  LoginChangePasswordInstanceTokenLazyRoute: typeof LoginChangePasswordInstanceTokenLazyRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginForgotPasswordLazyRoute: LoginForgotPasswordLazyRoute,
  LoginIndexRoute: LoginIndexRoute,
  LoginChangePasswordInstanceTokenLazyRoute:
    LoginChangePasswordInstanceTokenLazyRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRouteWithChildren,
  BridgeRoute: BridgeRoute,
  OauthConsentRoute: OauthConsentRoute,
  ShortlistInstanceTokenRoute: ShortlistInstanceTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
